import React from 'react'
import CommentIcon from './comment.svg'
import GiftIcon from './gift.svg'
import styles from './styles.css'
import { Image, GridItem } from '@deal/components'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'

interface Props {
  messageCount: number
  itemCount: number
  banner?: string | null
  expertFirstName?: string | null
  children: React.ReactNode
  isPlaceholderExpert: boolean | null
}

const RightProgress: React.SFC<Props> = ({
  messageCount,
  itemCount,
  isPlaceholderExpert,
  banner,
  expertFirstName,
  children
}) => {
  const sharedImageAttributes = {
    fm: 'pjpg',
    q: 90
  }

  return (
    <div className={styles.hero}>
      {banner && (
        <div className={styles.heroImageContent}>
          <SidebarAwareGrid
            margins={false}
            className={styles.heroImageGrid}
            wrapperClassName={styles.heroImageGridWrapper}
          >
            <GridItem col={2} className={styles.heroImageGridItem}>
              <Image
                src={banner}
                lazyLoad={false}
                imgixParams={sharedImageAttributes}
                className={styles.heroImage}
                width={650}
              />
              <div className={styles.heroImageOverlay} />
            </GridItem>
          </SidebarAwareGrid>
        </div>
      )}

      <div className={styles.overlay}>
        <SidebarAwareGrid>
          <GridItem col={2}>
            <div className={styles.wrapper}>
              <div className={styles.left}>{children}</div>
              {!isPlaceholderExpert && (
                <div className={styles.right}>
                  <div className={styles.title}>
                    {expertFirstName ? <>your progress with {expertFirstName}</> : 'your progress'}
                  </div>
                  <div className={styles.stat}>
                    <CommentIcon className={styles.icon} />{' '}
                    <div>
                      <div className={styles.count}>{messageCount}</div> messages
                    </div>
                  </div>
                  <div className={styles.stat}>
                    <GiftIcon className={styles.icon} />
                    <div>
                      <div className={styles.count}>{itemCount}</div>{' '}
                      {itemCount > 1 ? 'items' : 'item'} recommended
                    </div>
                  </div>
                </div>
              )}
            </div>
          </GridItem>
        </SidebarAwareGrid>
      </div>
    </div>
  )
}

export default RightProgress
